<template>
  <div class="auth-form">
    <p class="auth-form__legend">Please enter new password.</p>
    <form @submit.prevent="resetPassword">
      <slot
        name="password"
        :password="password"
        :errors="errors.password"
        :passwordInputCheck="passwordInputCheck"
        :passwordBlurCheck="passwordBlurCheck"
        :update="update"
      >
        <label for="password" class="auth-form__label">
          New password
          <input
            id="password"
            ref="password"
            v-model="password"
            type="password"
            class="auth-form__input"
            required
            aria-required="true"
            :aria-invalid="!!errors.password.length"
            aria-describedby="password-desc"
            @input="passwordInputCheck"
            @blur="passwordBlurCheck"
          />
          <span
            id="password-desc"
            v-if="!errors.password.includes('Passwords should be at least 10 characters long')"
          >
            Passwords should be at least 10 characters long
          </span>
        </label>
      </slot>
      <span class="auth-form__error" id="emailError" role="alert" v-if="errors.password.length">
        <div v-for="error in errors.password" :key="error">
          <span class="sr-only">Error:</span>{{ error }}
        </div>
      </span>

      <slot
        name="passwordConf"
        :passwordConf="passwordConf"
        :errors="errors.passwordConf"
        :passwordConfBlurCheck="passwordConfBlurCheck"
        :update="update"
      >
        <label for="passwordConf" class="auth-form__label">
          Confirm Password
          <input
            id="passwordConf"
            ref="passwordConf"
            v-model="passwordConf"
            type="password"
            class="auth-form__input"
            required
            aria-required="true"
            :aria-invalid="!!errors.passwordConf.length"
            @blur="passwordConfBlurCheck"
          />
        </label>
      </slot>
      <span class="auth-form__error" id="emailError" role="alert" v-if="errors.passwordConf.length">
        <div v-for="error in errors.passwordConf" :key="error">
          <span class="sr-only">Error:</span>{{ error }}
        </div>
      </span>

      <button class="auth-form__input" type="submit">Register</button>
    </form>
  </div>
</template>

<script>
import Validator from '../../lib/password/registerFormValidatior';

export default {
  name: 'resetPassword',
  props: {
    uidb64: {
      type: String,
      default: () => '',
    },
    token: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      password: '',
      passwordConf: '',
      validator: null,
      message: null,
      errors: {
        email: [],
        password: [],
        passwordConf: [],
      },
    };
  },
  mounted() {
    this.validator = new Validator(this.$data);
  },
  methods: {
    async resetPassword() {
      try {
        if (!this.validateForm()) return;
        await this.$pigeonline.authService.resetPassword(this.uidb64, this.token, this.password);
        this.$emit('success');
      } catch (e) {
        //console.error(e);

        const data = e.response.data;

        Object.keys(this.errors).forEach((key) => {
          if (key in data) {
            this.errors[key] = data[key];
          }
        });

        this.message = 'There was an error updating your password. Please try again later.';
        this.$emit('error');
      }
    },
    passwordInputCheck() {
      this.errors.password = this.validator.validate('password', 'input');
    },
    passwordBlurCheck() {
      this.errors.password = this.validator.validate('password', 'blur');
    },
    passwordConfBlurCheck() {
      this.errors.passwordConf = this.validator.validate('passwordConf', 'blur');
    },
    validateForm() {
      ['password', 'passwordConf'].forEach((field) => {
        this.errors[field] = this.validator.validate(field, 'submit');
      });

      return (
        Object.keys(this.errors).reduce((acc, key) => {
          acc = acc + this.errors[key].length;
          return acc;
        }, 0) === 0
      );
    },
    update(field, val) {
      this[field] = val;
    },
    /**
     * Set focus to input field with id = key
     * This is to address chrome bug where pressing enter submits form insead
     * of setting focus to input field.
     * This is also to address firefox bug that does not give focus on click.
     */
    setFocus(key) {
      this.$refs[key].focus();
    },
  },
};
</script>

<style src="./auth-styles.css"></style>
